@import './theme.css';
@import '../../node_modules/tailwindcss/base.css';
@import '../../node_modules/@pandiafi/design-system/lib/index.css';
@import '../../node_modules/tailwindcss/components.css';
@import '../../node_modules/tailwindcss/utilities.css';
